import { h } from "@stencil/core";
import { applicationsLaser, applicationsOptics, applicationsWelding } from "../../../api/applications";
import { TranslationKey } from "../../../utils/loadTranslations";

export const ApplicationSelect = ({ t, formStore }) => (
    <ux-select
        required
        label={t("field.application.label")}
        data-validation-required--msg={t("validation.requiredField")}
        name="application"
        onUxChange={(event) => {
            formStore.state.selectedApplication = Number(event.detail.value);
        }}
    >
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsLaser.map((application) => (
            <option value={application.id}>{t(`application.${application.labelKey}` as TranslationKey)}</option>
        ))}
    </ux-select>
);

export const ApplicationOpticsSelect = ({ t }) => (
    <ux-select label={t("field.optics.label")} name="optics">
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsOptics.map((application) => (
            <option value={application.id}>{t(`application.${application.labelKey}` as TranslationKey)}</option>
        ))}
    </ux-select>
);

export const ApplicationIssueSelect = ({ t }) => (
    <ux-select label={t("field.applicationIssue.label")} name="applicationIssue">
        <option value="" selected disabled>
            {t("select.placeholder")}
        </option>
        {applicationsWelding.map((application) => (
            <option value={application.id}>{t(`application.${application.labelKey}` as TranslationKey)}</option>
        ))}
    </ux-select>
);
